export const AUDIO_URL = "https://eals-slp-bucket.s3.us-west-1.amazonaws.com/";
export const UPLOAD_IMAGE_URL = "/admin/uploadimage";
export const DATE_FORMAT = "MM/DD/YYYY";

export const DEMOGRAPHICS_FORM_ELEMENTS = [
    {
      id: 1,
      title: "Physical gender at birth",
      field: "gender",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 101,
          subtitle: "Male",
        },
        {
          subId: 102,
          subtitle: "Female",
        },
      ],
    },
    {
      id: 2,
      title: "Ethnicity",
      field: "ethnicity",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 201,
          subtitle: "Not of Hispanic, Latino/a or Spanish origin ",
        },
        {
          subId: 202,
          subtitle: "Mexican, Mexican American, Chicano/a",
        },
        {
          subId: 203,
          subtitle: "Puerto Rican",
        },
        {
          subId: 204,
          subtitle: "Cuban",
        },
  
        {
          subId: 206,
          subtitle: "Another Hispanic Latino/a or Spanish origin",
        },
        {
          subId: 207,
          subtitle: "Other",
        },
        {
          subId: 208,
          subtitle: "Decline to answer",
        },
      ],
    },
    {
      id: 3,
      title: "What is your dominant hand?",
      field: "dominantHand",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 301,
          subtitle: "Right",
        },
        {
          subId: 302,
          subtitle: "Left",
        },
        {
          subId: 303,
          subtitle: "Ambidextrous",
        },
      ],
    },
    {
      id: 4,
      title: "Smoking History",
      field: "smokingHistory",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 401,
          subtitle: "I currently smoke",
        },
        {
          subId: 402,
          subtitle: "I previously smoked",
        },
        {
          subId: 403,
          subtitle: "I have never smoked",
        },
      ],
    },
    {
      id: 5,
      title: "Highest level of Education",
      field: "heightLevelEducation",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 501,
          subtitle: "No formal education",
        },
        {
          subId: 502,
          subtitle: "Elementary School",
        },
        {
          subId: 503,
          subtitle: "High School",
        },
        {
          subId: 504,
          subtitle: "College",
        },
        {
          subId: 505,
          subtitle: "Vocational Training",
        },
        {
          subId: 506,
          subtitle: "University",
        },
        {
          subId: 507,
          subtitle: "Masters",
        },
        {
          subId: 508,
          subtitle: "Doctorate",
        },
        {
          subId: 509,
          subtitle: "Other",
        },
      ],
    },
    {
      id: 6,
      title: "Is English your first language?",
      field: "firstLanguage",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 601,
          subtitle: "Yes",
        },
        {
          subId: 602,
          subtitle: "No",
          subData: [
            {
              subDataId: 60201,
              subDataTitle: "Arabic",
            },
            {
              subDataId: 60202,
              subDataTitle: "French",
            },
            {
              subDataId: 60203,
              subDataTitle: "German",
            },
            {
              subDataId: 60204,
              subDataTitle: "Hindi",
            },
            {
              subDataId: 60205,
              subDataTitle: "Japanese",
            },
            {
              subDataId: 60206,
              subDataTitle: "Korean",
            },
            {
              subDataId: 60207,
              subDataTitle: "Mandarin",
            },
            {
              subDataId: 60208,
              subDataTitle: "Portuguese",
            },
            {
              subDataId: 60209,
              subDataTitle: "Spanish",
            },
            {
              subDataId: 60210,
              subDataTitle: "Russian",
            },
            {
              subDataId: 60211,
              subDataTitle: "Urdu",
            },
            {
              subDataId: 60212,
              subDataTitle: "Other",
            },
          ],
        },
      ],
    },
    {
      id: 7,
      title: "Dementia",
      field: "dementia",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 701,
          subtitle: "Yes",
        },
        {
          subId: 702,
          subtitle: "No",
        },
      ],
    },
    {
      id: 8,
      title: "Diagnosis",
      field: "diagnosis",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 801,
          subtitle: "ALS",
          subData: [
            {
              subDataId: 80101,
              subDataTitle: "Known ALS Gene",
            },
            {
              subDataId: 80102,
              subDataTitle: "Unsure",
            },
          ],
        },
        {
          subId: 802,
          subtitle: "ALS and Fronto-Temporal Dementia",
        },
        {
          subId: 803,
          subtitle: "Unsure",
        },
        {
          subId: 804,
          subtitle: "Any other Neurologic diagnosis",
          subData: [
            {
              subDataId: 80401,
              subDataTitle: "Dementia",
            },
            {
              subDataId: 80402,
              subDataTitle: "Muscular Disease",
            },
            {
              subDataId: 80403,
              subDataTitle: "Other",
            },
          ],
        },
      ],
    },
    {
      id: 9,
      title: "Site of Symptom Onset",
      field: "siteOfOnset",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 901,
          subtitle: "Generalized",
        },
        {
          subId: 902,
          subtitle: "Bulbar",
          subData: [
            {
              subDataId: 90201,
              subDataTitle: "Speech",
            },
            {
              subDataId: 90202,
              subDataTitle: "Swallowing",
            },
          ],
        },
        {
          subId: 903,
          subtitle: "Neck weakness",
        },
        {
          subId: 904,
          subtitle: "Trunk weakness",
        },
        {
          subId: 905,
          subtitle: "Respiratory ",
        },
        {
          subId: 906,
          subtitle: "Limb",
          subData: [
            {
              subDataId: 90601,
              subDataTitle: "Upper right hand/finger",
            },
            {
              subDataId: 90602,
              subDataTitle: "Upper right Arm",
            },
            {
              subDataId: 90603,
              subDataTitle: "Upper left hand/finger",
            },
            {
              subDataId: 90604,
              subDataTitle: "Upper left Arm",
            },
            {
              subDataId: 90605,
              subDataTitle: "Lower right ankle/foot/toes",
            },
            {
              subDataId: 90606,
              subDataTitle: "Lower right leg",
            },
            {
              subDataId: 90607,
              subDataTitle: "Lower lower ankle/foot/toes",
            },
            {
              subDataId: 90608,
              subDataTitle: "Lower lower leg",
            },
          ],
        },
        {
          subId: 907,
          subtitle: "Other site of symptoms",
        },
      ],
    },
    {
      id: 10,
      title: "Do you have any allergies?",
      field: "allergies",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 1001,
          subtitle: "Yes",
        },
        {
          subId: 1002,
          subtitle: "No",
        },
      ],
    },
    {
      id: 11,
      title: "Brain Aneurysm",
      field: "brainAneurysm",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 1101,
          subtitle: "Yes",
        },
        {
          subId: 1102,
          subtitle: "No",
        },
      ],
    },
    {
      id: 12,
      title: "Bipolar disorder",
      field: "bipolarDisorder",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 1201,
          subtitle: "Yes",
        },
        {
          subId: 1202,
          subtitle: "No",
        },
      ],
    },
    {
      id: 13,
      title: "Cancer",
      field: "cancer",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 1301,
          subtitle: "Yes",
        },
        {
          subId: 1302,
          subtitle: "No",
        },
      ],
    },
    {
      id: 14,
      title: "Diabetes",
      field: "diabetes",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 1401,
          subtitle: "Yes",
        },
        {
          subId: 1402,
          subtitle: "No",
        },
      ],
    },
    {
      id: 15,
      title: "Depression",
      field: "depression",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 1501,
          subtitle: "Yes",
        },
        {
          subId: 1502,
          subtitle: "No",
        },
      ],
    },
    {
      id: 16,
      title: "Epilepsy",
      field: "epilepsy",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 1601,
          subtitle: "Yes",
        },
        {
          subId: 1602,
          subtitle: "No",
        },
      ],
    },
    {
      id: 17,
      title: "Muscle Disease",
      field: "muscleDisease",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 1701,
          subtitle: "Yes",
        },
        {
          subId: 1702,
          subtitle: "No",
        },
      ],
    },
    {
      id: 18,
      title: "Other",
      field: "other",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 1801,
          subtitle: "Yes",
        },
        {
          subId: 1802,
          subtitle: "No",
        },
      ],
    },
    {
      id: 19,
      title: "Schizophrenia",
      field: "schizophrenia",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 1901,
          subtitle: "Yes",
        },
        {
          subId: 1902,
          subtitle: "No",
        },
      ],
    },
    {
      id: 20,
      title: "ADHD/ADD",
      field: "ADHD_ADD",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 2001,
          subtitle: "Yes",
        },
        {
          subId: 2002,
          subtitle: "No",
        },
      ],
    },
    {
      id: 21,
      title: "Anxiety",
      field: "anxiety",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 2101,
          subtitle: "Yes",
        },
        {
          subId: 2102,
          subtitle: "No",
        },
      ],
    },
    {
      id: 22,
      title: "Residence type",
      field: "residenceType",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 2201,
          subtitle: "Apartment",
        },
        {
          subId: 2202,
          subtitle: "Condo/townhouse",
        },
        {
          subId: 2203,
          subtitle: "House",
        },
        {
          subId: 2204,
          subtitle: "Mobile home",
        },
        {
          subId: 2205,
          subtitle: "Other",
        },
      ],
    },
    {
      id: 23,
      title: "Marital status",
      field: "maritalStatus",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 2301,
          subtitle: "Single",
        },
        {
          subId: 2302,
          subtitle: "Separated",
        },
        {
          subId: 2303,
          subtitle: "Married",
        },
      ],
    },
    {
      id: 24,
      title: "Race",
      field: "race",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 2401,
          subtitle: "White",
        },
        {
          subId: 2402,
          subtitle: "Black or African American ",
        },
        {
          subId: 2403,
          subtitle: "American Indian or Alaska Native",
        },
        {
          subId: 2404,
          subtitle: "Asian Indian",
        },
        {
          subId: 2405,
          subtitle: "Chinese",
        },
        {
          subId: 2406,
          subtitle: "Filipino",
        },
        {
          subId: 2407,
          subtitle: "Japanese",
        },
        {
          subId: 2408,
          subtitle: "Korean",
        },
        {
          subId: 2409,
          subtitle: "Vietnamese",
        },
        {
          subId: 2410,
          subtitle: "Other Asian",
        },
        {
          subId: 2411,
          subtitle: "Native Hawaiian",
        },
        {
          subId: 2412,
          subtitle: "Other Pacific Islander",
        },
        {
          subId: 2413,
          subtitle: "Unknown",
        },
        {
          subId: 2414,
          subtitle: "Other",
        },
        {
          subId: 2415,
          subtitle: "Decline to answer",
        },
      ],
    },
    {
      id: 25,
      title: "Which region in the United States do you consider yourself from?",
      field: "region",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 2501,
          subtitle: "Northeast",
        },
        {
          subId: 2502,
          subtitle: "South",
        },
        {
          subId: 2503,
          subtitle: "Midwest",
        },
        {
          subId: 2504,
          subtitle: "West",
        },
      ],
    },
    {
      id: 26,
      title: "Have you quit smoking in the past year?",
      field: "quitSmoking",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 2601,
          subtitle: "Yes",
        },
        {
          subId: 2602,
          subtitle: "No",
        },
      ],
    },
    {
      id: 27,
      title: "Asthma",
      field: "asthma",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 2701,
          subtitle: "Yes",
        },
        {
          subId: 2702,
          subtitle: "No",
        },
      ],
    },
    {
      id: 28,
      title: "COPD",
      field: "COPD",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 2801,
          subtitle: "Yes",
        },
        {
          subId: 2802,
          subtitle: "No",
        },
      ],
    },
    {
      id: 29,
      title: "Migraines",
      field: "migraines",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 2901,
          subtitle: "Yes",
        },
        {
          subId: 2902,
          subtitle: "No",
        },
      ],
    },
    {
      id: 30,
      title: "Concussion (s)",
      field: "concussion",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 3001,
          subtitle: "Yes",
        },
        {
          subId: 3002,
          subtitle: "No",
        },
      ],
    },
    {
      id: 31,
      title: "Cognitive Impairment",
      field: "cognitiveImpairment",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 3101,
          subtitle: "Yes",
        },
        {
          subId: 3102,
          subtitle: "No",
        },
      ],
    },
    {
      id: 32,
      title: "C9ORF mutation",
      field: "mutation",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 3201,
          subtitle: "Yes",
        },
        {
          subId: 3202,
          subtitle: "No",
        },
      ],
    },
    {
      id: 33,
      title:
        "Do you have a positive family history for ALS or any other neurodegenerative disease (Frontotemporal Dementia, Parkinson’s Disease, Altzheimer’s Disease)?",
      field: "positiveFamilyHistory",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 3301,
          subtitle: "Yes",
        },
        {
          subId: 3302,
          subtitle: "No",
        },
      ],
    },
    {
      id: 34,
      title: "Do any of the following apply to you?",
      field: "applyYou",
      darkColor: "#FB6C66",
      lightColor: "#FFEEE4",
      content: [
        {
          subId: 3401,
          subtitle: "Hearing impaired / wear a hearing aid",
        },
        {
          subId: 3402,
          subtitle: "Vision impaired / wear glasses",
        },
        {
          subId: 3403,
          subtitle: "Currently wearing a dental appliance or dentures",
        },
        {
          subId: 3404,
          subtitle: "None of the above",
        },
      ],
    },
    {
      id: 35,
      title: "How are your stairs at your house?",
      field: "stairs",
      darkColor: "#8870E6",
      lightColor: "#F0ECFF",
      content: [
        {
          subId: 3501,
          subtitle: "Straight",
        },
        {
          subId: 3502,
          subtitle: "“L” Shaped",
        },
        {
          subId: 3503,
          subtitle: "“U” Shaped",
        },
        {
          subId: 3504,
          subtitle: "Spiral",
        },
        {
          subId: 3505,
          subtitle: "Other stairs",
        },
      ],
    },
    {
      id: 36,
      title: "What is the flooring of your stairs?",
      field: "flooring",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 3601,
          subtitle: "Carpeted",
        },
        {
          subId: 3602,
          subtitle: "Wood",
        },
      ],
    },
    {
      id: 37,
      title: "Do you have stairs at home?",
      field: "haveStairs",
      darkColor: "#44B277",
      lightColor: "#E1F7EC",
      content: [
        {
          subId: 3701,
          subtitle: "Yes",
        },
        {
          subId: 3702,
          subtitle: "No",
        },
      ],
    },
  ];
  
export const DEMOGRAPHIC_SELECT_LIST = {
MARITAL_STATUS: [
    {
    subId: 2301,
    subtitle: "Single",
    },
    {
    subId: 2302,
    subtitle: "Separated",
    },
    {
    subId: 2303,
    subtitle: "Married",
    },
],
RESIDENCE_TYPE: [
    {
    subId: 2201,
    subtitle: "Apartment",
    },
    {
    subId: 2202,
    subtitle: "Condo/townhouse",
    },
    {
    subId: 2203,
    subtitle: "House",
    },
    {
    subId: 2204,
    subtitle: "Mobile home",
    },
    {
    subId: 2205,
    subtitle: "Other",
    },
],
GENDER: [
    {
    subId: 101,
    subtitle: "Male",
    },
    {
    subId: 102,
    subtitle: "Female",
    },
],
RACE: [
    {
    subId: 2401,
    subtitle: "White",
    },
    {
    subId: 2402,
    subtitle: "Black or African American ",
    },
    {
    subId: 2403,
    subtitle: "American Indian or Alaska Native",
    },
    {
    subId: 2404,
    subtitle: "Asian Indian",
    },
    {
    subId: 2405,
    subtitle: "Chinese",
    },
    {
    subId: 2406,
    subtitle: "Filipino",
    },
    {
    subId: 2407,
    subtitle: "Japanese",
    },
    {
    subId: 2408,
    subtitle: "Korean",
    },
    {
    subId: 2409,
    subtitle: "Vietnamese",
    },
    {
    subId: 2410,
    subtitle: "Other Asian",
    },
    {
    subId: 2411,
    subtitle: "Native Hawaiian",
    },
    {
    subId: 2412,
    subtitle: "Other Pacific Islander",
    },
    {
    subId: 2413,
    subtitle: "Unknown",
    },
    {
    subId: 2414,
    subtitle: "Other",
    },
    {
    subId: 2415,
    subtitle: "Decline to answer",
    },
],
ETHNICITY: [
    {
    subId: 201,
    subtitle: "Not of Hispanic, Latino/a or Spanish origin ",
    },
    {
    subId: 202,
    subtitle: "Mexican, Mexican American, Chicano/a",
    },
    {
    subId: 203,
    subtitle: "Puerto Rican",
    },
    {
    subId: 204,
    subtitle: "Cuban",
    },

    {
    subId: 206,
    subtitle: "Another Hispanic Latino/a or Spanish origin",
    },
    {
    subId: 207,
    subtitle: "Other",
    },
    {
    subId: 208,
    subtitle: "Decline to answer",
    },
],
LANGUAGE: [
    {
    subId: 601,
    subtitle: "Yes",
    },
    {
    subId: 602,
    subtitle: "No",
    subData: [
        {
        subDataId: 60201,
        subDataTitle: "Arabic",
        },
        {
        subDataId: 60202,
        subDataTitle: "French",
        },
        {
        subDataId: 60203,
        subDataTitle: "German",
        },
        {
        subDataId: 60204,
        subDataTitle: "Hindi",
        },
        {
        subDataId: 60205,
        subDataTitle: "Japanese",
        },
        {
        subDataId: 60206,
        subDataTitle: "Korean",
        },
        {
        subDataId: 60207,
        subDataTitle: "Mandarin",
        },
        {
        subDataId: 60208,
        subDataTitle: "Portuguese",
        },
        {
        subDataId: 60209,
        subDataTitle: "Spanish",
        },
        {
        subDataId: 60210,
        subDataTitle: "Russian",
        },
        {
        subDataId: 60211,
        subDataTitle: "Urdu",
        },
        {
        subDataId: 60212,
        subDataTitle: "Other",
        },
    ],
    },
],
US_REGIONS: [
    {
    subId: 2501,
    subtitle: "Northeast",
    },
    {
    subId: 2502,
    subtitle: "South",
    },
    {
    subId: 2503,
    subtitle: "Midwest",
    },
    {
    subId: 2504,
    subtitle: "West",
    },
],
HIGHEST_LEVEL_EDUCATION: [
    {
    subId: 501,
    subtitle: "No formal education",
    },
    {
    subId: 502,
    subtitle: "Elementary School",
    },
    {
    subId: 503,
    subtitle: "High School",
    },
    {
    subId: 504,
    subtitle: "College",
    },
    {
    subId: 505,
    subtitle: "Vocational Training",
    },
    {
    subId: 506,
    subtitle: "University",
    },
    {
    subId: 507,
    subtitle: "Masters",
    },
    {
    subId: 508,
    subtitle: "Doctorate",
    },
    {
    subId: 509,
    subtitle: "Other",
    },
],
DOMINANT_HAND: [
    {
    subId: 301,
    subtitle: "Right",
    },
    {
    subId: 302,
    subtitle: "Left",
    },
    {
    subId: 303,
    subtitle: "Ambidextrous",
    },
],
SMOKING_HISTORY: [
    {
    subId: 401,
    subtitle: "I currently smoke",
    },
    {
    subId: 402,
    subtitle: "I previously smoked",
    },
    {
    subId: 403,
    subtitle: "I have never smoked",
    },
],
SMOKING_QUITE: [
    {
    subId: 2601,
    subtitle: "Yes",
    },
    {
    subId: 2602,
    subtitle: "No",
    },
],
YES_NO_QUESTIONS: [
    {
    title: "ADHD/ADD",
    stateName: "adhd_add",
    options: [
        {
        subId: 2001,
        subtitle: "Yes",
        },
        {
        subId: 2002,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Anxiety",
    stateName: "anxiety",
    options: [
        {
        subId: 2101,
        subtitle: "Yes",
        },
        {
        subId: 2102,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Bipolar disorder",
    stateName: "bipolarDisorder",
    options: [
        {
        subId: 1201,
        subtitle: "Yes",
        },
        {
        subId: 1202,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Brain Aneurysm",
    stateName: "brainAneurysm",
    options: [
        {
        subId: 1101,
        subtitle: "Yes",
        },
        {
        subId: 1102,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Cancer",
    stateName: "cancer",
    options: [
        {
        subId: 1301,
        subtitle: "Yes",
        },
        {
        subId: 1302,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Concussion (s)",
    stateName: "concussion",
    options: [
        {
        subId: 3001,
        subtitle: "Yes",
        },
        {
        subId: 3002,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Cognitive Impairment",
    stateName: "cognitiveImpairment",
    options: [
        {
        subId: 3101,
        subtitle: "Yes",
        },
        {
        subId: 3102,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Dementia",
    stateName: "dementia",
    options: [
        {
        subId: 701,
        subtitle: "Yes",
        },
        {
        subId: 702,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Depression",
    stateName: "depression",
    options: [
        {
        subId: 1501,
        subtitle: "Yes",
        },
        {
        subId: 1502,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Diabetes",
    stateName: "diabetes",
    options: [
        {
        subId: 1401,
        subtitle: "Yes",
        },
        {
        subId: 1402,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Epilepsy",
    stateName: "epilepsy",
    options: [
        {
        subId: 1601,
        subtitle: "Yes",
        },
        {
        subId: 1602,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Muscle Disease",
    stateName: "muscleDisease",
    options: [
        {
        subId: 1701,
        subtitle: "Yes",
        },
        {
        subId: 1702,
        subtitle: "No",
        },
    ],
    },
    {
    title: "Schizophrenia",
    stateName: "schizophrenia",
    options: [
        {
        subId: 1901,
        subtitle: "Yes",
        },
        {
        subId: 1902,
        subtitle: "No",
        },
    ],
    },
],
ADHD_ADD: [
    {
    subId: 2001,
    subtitle: "Yes",
    },
    {
    subId: 2002,
    subtitle: "No",
    },
],
ANXIETY: [
    {
    subId: 2101,
    subtitle: "Yes",
    },
    {
    subId: 2102,
    subtitle: "No",
    },
],
diagnosis: [
    {
    subId: 801,
    subtitle: "ALS",
    subData: [
        {
        subDataId: 80101,
        subDataTitle: "Known ALS Gene",
        },
        {
        subDataId: 80102,
        subDataTitle: "Unsure",
        },
    ],
    },
    {
    subId: 802,
    subtitle: "ALS and Fronto-Temporal Dementia",
    },
    {
    subId: 803,
    subtitle: "Unsure",
    },
    {
    subId: 804,
    subtitle: "Any other Neurologic diagnosis",
    subData: [
        {
        subDataId: 80401,
        subDataTitle: "Dementia",
        },
        {
        subDataId: 80402,
        subDataTitle: "Muscular Disease",
        },
        {
        subDataId: 80403,
        subDataTitle: "Other",
        },
    ],
    },
],
diagnosis_als: [
    {
    subDataId: 80101,
    subDataTitle: "Known ALS Gene",
    },
    {
    subDataId: 80102,
    subDataTitle: "Unsure",
    },
],
diagnosis_any_other: [
    {
    subDataId: 80401,
    subDataTitle: "Dementia",
    },
    {
    subDataId: 80402,
    subDataTitle: "Muscular Disease",
    },
    {
    subDataId: 80403,
    subDataTitle: "Other",
    },
],
c9orf_mutation: [
    {
    subId: 3201,
    subtitle: "Yes",
    },
    {
    subId: 3202,
    subtitle: "No",
    },
],
symptom_onset: [
    {
    subId: 901,
    subtitle: "Generalized",
    },
    {
    subId: 902,
    subtitle: "Bulbar",
    subData: [
        {
        subDataId: 90201,
        subDataTitle: "Speech",
        },
        {
        subDataId: 90202,
        subDataTitle: "Swallowing",
        },
    ],
    },
    {
    subId: 903,
    subtitle: "Neck weakness",
    },
    {
    subId: 904,
    subtitle: "Trunk weakness",
    },
    {
    subId: 905,
    subtitle: "Respiratory ",
    },
    {
    subId: 906,
    subtitle: "Limb",
    subData: [
        {
        subDataId: 90601,
        subDataTitle: "Upper right hand/finger",
        },
        {
        subDataId: 90602,
        subDataTitle: "Upper right Arm",
        },
        {
        subDataId: 90603,
        subDataTitle: "Upper left hand/finger",
        },
        {
        subDataId: 90604,
        subDataTitle: "Upper left Arm",
        },
        {
        subDataId: 90605,
        subDataTitle: "Lower right ankle/foot/toes",
        },
        {
        subDataId: 90606,
        subDataTitle: "Lower right leg",
        },
        {
        subDataId: 90607,
        subDataTitle: "Lower left ankle/foot/toes",
        },
        {
        subDataId: 90608,
        subDataTitle: "Lower left leg",
        },
    ],
    },
    {
    subId: 907,
    subtitle: "Other site of symptoms",
    },
],
symptom_onset_limb: [
    {
    subDataId: 90601,
    subDataTitle: "Upper right hand/finger",
    },
    {
    subDataId: 90602,
    subDataTitle: "Upper right Arm",
    },
    {
    subDataId: 90603,
    subDataTitle: "Upper left hand/finger",
    },
    {
    subDataId: 90604,
    subDataTitle: "Upper left Arm",
    },
    {
    subDataId: 90605,
    subDataTitle: "Lower right ankle/foot/toes",
    },
    {
    subDataId: 90606,
    subDataTitle: "Lower right leg",
    },
    {
    subDataId: 90607,
    subDataTitle: "Lower left ankle/foot/toes",
    },
    {
    subDataId: 90608,
    subDataTitle: "Lower left leg",
    },
],
symptom_onset_bulbar: [
    {
    subDataId: 90201,
    subDataTitle: "Speech",
    },
    {
    subDataId: 90202,
    subDataTitle: "Swallowing",
    },
],
positionHistory: [
    {
    subId: 3301,
    subtitle: "Yes",
    },
    {
    subId: 3302,
    subtitle: "No",
    },
],
do_apply_to_all: [
    {
    subId: 3401,
    subtitle: "Hearing impaired / wear a hearing aid",
    },
    {
    subId: 3402,
    subtitle: "Vision impaired / wear glasses",
    },
    {
    subId: 3403,
    subtitle: "Currently wearing a dental appliance or dentures",
    },
    {
    subId: 3404,
    subtitle: "None of the above",
    },
],
do_you_have_stairs: [
    {
    subId: 3701,
    subtitle: "Yes",
    },
    {
    subId: 3702,
    subtitle: "No",
    },
],
how_stairs_are: [
    {
    subId: 3501,
    subtitle: "Straight",
    },
    {
    subId: 3502,
    subtitle: "“L” Shaped",
    },
    {
    subId: 3503,
    subtitle: "“U” Shaped",
    },
    {
    subId: 3504,
    subtitle: "Spiral",
    },
    {
    subId: 3505,
    subtitle: "Other stairs",
    },
],
flooring_of_your_stairs: [
    {
    subId: 3601,
    subtitle: "Carpeted",
    },
    {
    subId: 3602,
    subtitle: "Wood",
    },
],
};

export const GOOGLE_RECAPTCHA_SITE_KEY = "6Ld4za0qAAAAAKMl-CWy2SA0IypsOQO2f_llSz_i";
  
